import ActivityDetails from "PFApp/activities/show/activity_details.jsx";
import ActivityMatches from "PFApp/activities/show/activity_matches";
import { useActivityPageContext } from "PFApp/activities/show/activity_page_context";
import ActivityShortlist from "PFApp/activities/show/activity_shortlist.jsx";
import ActivityShowMenuButton from "PFApp/activities/show/details/activity_details_menu_button";
import { mapWorkflowStatesToUI } from "PFApp/audit_planner/parts/helpers";
import ViewInBookingModuleButton from "PFApp/components/view_in_booking_module_button";
import { useGrowl } from "PFApp/use_growl";
import { ActionIcon } from "PFComponents/action_icon";
import FolderTabs from "PFComponents/tabs/folder_tabs";
import PropTypes from "prop-types";
import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { Redirect, useHistory, useParams } from "react-router-dom";

import css from "./activity_tabs.module.scss";
import { isRoleDisabled } from "./helpers";

const ActivityTabs = ({ close }) => {
  const { tab: tabId, engagementId, section } = useParams();
  const history = useHistory();
  const { t } = useTranslation("auditPlanner");

  const {
    roles,
    isEngagement,
    isRole,
    canCreateRoles,
    matchesMeta,
    rankedShortlists,
    checkActivityPending,
    canSeeMatches,
    canSeeBookingModule,
    shortlistsMeta,
    suspendedShortlistsMeta,
    taskModel,
    task,
    comparisonToastWrapp
  } = useActivityPageContext();

  const growl = useGrowl();

  const shortListCount = (shortlistsMeta?.total || 0) + (suspendedShortlistsMeta?.total || 0);

  const onTabSelected = useCallback(
    (tab) => history.push(`/audit_planner/${section}/${engagementId}/${task.id}/${tab.id}`),
    [task.id]
  );

  if (isRoleDisabled(task)) {
    growl({
      kind: "alert",
      message: t("parts.noPermissionOrActivityPending")
    });

    return <Redirect to={"/audit_planner/control_centre"} />;
  }

  /* eslint-disable react/display-name */
  const TABS = [
    {
      id: "details",
      displayElement: t("parts.description"),
      Content: (
        <ActivityDetails
          roles={roles?.entries || []}
          isEngagement={isEngagement}
          isRole={isRole}
          canCreateRoles={canCreateRoles}
        />
      )
    },
    {
      id: "matches",
      displayElement: t("parts.matches"),
      count: matchesMeta.total,
      Content: (
        <ActivityMatches
          matchesMeta={matchesMeta}
          rankedShortlists={rankedShortlists}
          taskModel={taskModel}
          checkActivityPending={checkActivityPending}
          isEngagement={isEngagement}
          isRole={isRole}
          handleTitleClick={console.log}
        />
      )
    },
    {
      id: "shortlist",
      displayElement: t("parts.shortlist"),
      count: (shortlistsMeta?.total || 0) + (suspendedShortlistsMeta?.total || 0),
      Content: (
        <ActivityShortlist
          canSeeMatches={canSeeMatches}
          rankedShortlists={rankedShortlists}
          isEngagement={isEngagement}
          isRole={isRole}
          engagementId={engagementId}
          isAudit
          shortlistsMeta={shortlistsMeta}
          handleTitleClick={() => {}}
        />
      )
    }
  ];

  const ActionTabContent = (
    <>
      <ActivityShowMenuButton />
      <ActionIcon name="cross" onClick={close} size="xs" />
    </>
  );

  if (mapWorkflowStatesToUI(task.workflow_state) === "pending") {
    return <Redirect to="/audit_planner/control_centre" />;
  }

  const additionalContent = canSeeBookingModule ? (
    <div className={css.viewInBookingModuleContainer}>
      <ViewInBookingModuleButton openAllocateManually={tabId === "shortlist" && shortListCount > 0} />
    </div>
  ) : null;

  return (
    <>
      <FolderTabs
        tabs={TABS}
        selectedTabId={tabId}
        actionTabContent={ActionTabContent}
        onTabSelected={onTabSelected}
        additionalContent={additionalContent}
      />
      {comparisonToastWrapp}
    </>
  );
};

ActivityTabs.propTypes = {
  close: PropTypes.func,
  engagement: PropTypes.object.isRequired
};

export default ActivityTabs;
